/**
 * Date utility functions for handling date parsing and formatting
 */

/**
 * Parse a YYYY-MM-DD date string as a local date instead of UTC.
 * This prevents timezone-related date shifting issues.
 *
 * @param dateString - Date string in YYYY-MM-DD format
 * @returns Date object in local timezone
 *
 * @example
 * parseLocalDate('2025-11-03') // Returns Nov 3, 2025 in local timezone
 */
export const parseLocalDate = (dateString: string): Date => {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
};

/**
 * Format a Date object to YYYY-MM-DD string
 *
 * @param date - Date object to format
 * @returns Date string in YYYY-MM-DD format
 *
 * @example
 * formatDateToString(new Date(2025, 10, 3)) // Returns '2025-11-03'
 */
export const formatDateToString = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
